import {Link, styled} from '@mui/material';

export const HelperLink = styled(Link)(({theme}) => ({
  fontSize: theme.typography.pxToRem(15),
  color: '#4D5562',
  textDecorationColor: '#4D5562',
}));
